import gql from 'graphql-tag';

export const UPSERT_DEAL_BUILDER_CONTACTS = gql`
  mutation UpsertDealBuilderContacts($input: UpsertDealBuilderContactsInput!) {
    dealBuilder {
      upsertDealBuilderContacts(input: $input) {
        success
        error
        entity {
          proposalContactsId
          proposalId
          ownerPgId
          accountContactId
        }
      }
    }
  }
`;
